import {
  createSideNavModule,
  NavItem,
  prepareNavItems,
  CreateSideNavModuleArgs
} from '../../withNavLayout/withNavLayout';
import { Module } from '../XAppWrapper';

const determineNavItems = (combinedModules: Module[]) =>
  combinedModules.reduce<NavItem[]>((acc, { navItems, id }) => {
    if (!navItems) return acc;

    return [...acc, ...prepareNavItems(navItems, id)];
  }, []);

export const getSideNavModule = ({
  combinedModules,
  homePath
}: Pick<CreateSideNavModuleArgs, 'homePath'> & {
  combinedModules: Module[];
}) => {
  const headerItems = combinedModules.flatMap((x) => x.headerItems || []);

  const dynamicNavItemsProviders = combinedModules
    .filter((x) => x.dynamicNavItemsProviders)
    .map((x) => ({
      moduleTranslationsPre: x.id,
      fetchFns: x.dynamicNavItemsProviders || []
    }));

  const navItems = determineNavItems(combinedModules);

  return createSideNavModule({
    navItems,
    homePath,
    headerItems,
    dynamicNavItemsProviders
  });
};
